module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleSetting-box"
  }, [_c('div', {
    staticClass: "ruleLevel-btn-box"
  }, [_c('div', {
    staticClass: "pull-right",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLevel) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLevel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('draggable', {
    attrs: {
      "list": _vm.rule,
      "options": {
        group: 'levelGroup',
        disabled: _vm.onfocus
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.newRelation),
      callback: function($$v) {
        _vm.newRelation = $$v
      },
      expression: "newRelation"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.rule), function(levelItem, levelIndex) {
    return _c('div', {
      key: levelIndex,
      staticClass: "rule-content-box panel panel-default",
      class: {
        'disabled': !_vm.enable || _vm.version == '0'
      }
    }, [_c('div', {
      staticClass: "panel-heading title-bg"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('label', [(levelIndex !== _vm.rule.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLevel),
        expression: "checkedLevel"
      }],
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "value": levelIndex,
        "checked": Array.isArray(_vm.checkedLevel) ? _vm._i(_vm.checkedLevel, levelIndex) > -1 : (_vm.checkedLevel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLevel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = levelIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLevel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLevel = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "primary-color"
    }, [_vm._v("\n                  " + _vm._s(levelIndex == _vm.rule.length - 1 ? _vm.ruleSettingLan.currentSetting : levelIndex + 1 + _vm.ruleSettingLan.levelSetting) + "\n                  "), (levelIndex == _vm.rule.length - 1) ? _c('span', [_vm._v("\n                    (" + _vm._s(_vm.currentIB.id + '-' + _vm.currentIB.name) + ")\n                  ")]) : _c('span', [_vm._v("\n                    (\n                      " + _vm._s(_vm.newRelation[levelIndex].id !== 'not exist' ? _vm.newRelation[levelIndex].id + '-' + (_vm.newRelation[levelIndex].name === 'not exist' ? _vm.ruleSettingLan.notSalesSet : _vm.newRelation[levelIndex].name) : _vm.ruleSettingLan.notExist) + "\n                    )\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      style: (_vm.version == '0' ? 'visibility:hidden;' : '')
    }, [_c('button', {
      staticClass: "btn btn-style-add",
      attrs: {
        "disabled": !_vm.enable || _vm.version == '0'
      },
      on: {
        "click": function($event) {
          return _vm.addRule(levelItem)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v("\n                " + _vm._s(_vm.ruleSettingLan.addRule) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "list": levelItem,
        "options": {
          group: 'ruleGroup',
          disabled: _vm.onfocus
        }
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": function($event) {
          _vm.drag = false
        }
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": 'flip-list'
      }
    }, _vm._l((levelItem), function(ruleItem, ruleIndex) {
      return _c('div', {
        key: ruleIndex,
        staticClass: "panel-body"
      }, [_c('div', {
        staticClass: "rule-title"
      }, [_c('div', {
        staticClass: "pull-left primary-color"
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.rule) + _vm._s(ruleIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "pull-right",
        style: (_vm.version == '0' ? 'visibility:hidden;' : '')
      }, [_c('button', {
        staticClass: "btn btn-xs",
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0'
        },
        on: {
          "click": function($event) {
            return _vm.removeRule(levelItem, ruleIndex)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-trash"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })]), _vm._v(" "), _c('div', {
        staticClass: "rule-content"
      }, [_c('div', {
        staticClass: "form-horizontal",
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "form-group",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "col-sm-6"
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enable || _vm.version == '0'
        },
        domProps: {
          "value": false,
          "checked": _vm._q(ruleItem.enableCommTarget, false)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", false)
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.toOriginalAccount) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enable || _vm.version == '0'
        },
        domProps: {
          "value": true,
          "checked": _vm._q(ruleItem.enableCommTarget, true)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", true)
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.toTargetAccount) + "\n                      ")])]), _vm._v(" "), _c('label', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.commTarget),
          expression: "ruleItem.commTarget"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|numeric'),
          expression: "'required|numeric'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0' || !ruleItem.enableCommTarget,
          "name": levelIndex + '_' + ruleIndex + '_' + 'commTarget'
        },
        domProps: {
          "value": (ruleItem.commTarget)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "change": function($event) {
            return _vm.checkId(ruleItem)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "commTarget", $event.target.value)
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "form-inline",
        class: {
          'col-sm-6 row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enable || _vm.version == '0',
          "checked": ""
        },
        domProps: {
          "value": 0
        }
      }), _vm._v("\n                      " + _vm._s(_vm.ruleSettingLan.customTheMoney) + "\n                    ")])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return _c('option', {
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                          " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                        ")])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enable || _vm.version == '0'
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                          ")]) : _vm._e()
      })], 2)], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.0001|decimal:4'),
          expression: "'required|min_value:0.0001|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value1') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'value1'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.clientType),
          expression: "ruleItem.clientType"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'clientType') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'clientType'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "clientType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": 0
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.allClient))]), _vm._v(" "), _c('option', {
        domProps: {
          "value": 1
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.IBClient))]), _vm._v(" "), _c('option', {
        domProps: {
          "value": 2
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.directClient))])])])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })])])
    }), 0)], 1)], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34306e10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/Sale/SaleSetting/ruleSetting.vue
// module id = 1095
// module chunks = 1